import React from 'react';
type CTAButtonProps = {
  children: React.ReactNode;
  href: string;
  variant?: 'primary' | 'outline';
  className?: string;
};
export function CTAButton({
  children,
  href,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const base = 'inline-flex w-full items-center justify-center rounded-full px-5 py-4 text-center text-xs font-extrabold uppercase leading-tight tracking-wide transition-transform duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900 sm:px-6 sm:text-sm';
  const styles = variant === 'primary' ? 'bg-brand-500 text-ink-900 shadow-[0_0_35px_rgba(249,115,22,0.45)] hover:bg-brand-400' : 'border border-brand-500/60 bg-transparent text-brand-400 hover:border-brand-400 hover:text-brand-500';
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`${base} ${styles} ${className}`} data-id="element-53" data-mp="38pa9xnqh04xf">
      {children}
    </a>;
}